import script from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatContainer.vue?vue&type=script&setup=true&lang=js"

import "./ChatContainer.vue?vue&type=style&index=0&id=3dbec5f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbec5f8"]])

export default __exports__